<template>
  <a-modal
    width="600px"
    title="分配标注子任务"
    v-model:visible="visible"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form
      class="detail-form"
      ref="form"
      :model="form"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }">
      <a-form-item label="子任务名称">
        {{ form.name }}
      </a-form-item>
      <a-form-item label="子任务量">
        {{ taskNum }}
      </a-form-item>
      <a-form-item label="选择标注员">
        <!--<a-select
          v-model:value="form.excuteUserId"
          @change="changeHandle"
        >
          <a-select-option v-for="item in tableData" :key="item.userId">
            {{getUserName(item.userId)}}
          </a-select-option>
         &lt;!&ndash; <a-select-option key="标注员1">
            标注员1
          </a-select-option>
          <a-select-option key="标注员2">
            标注员2
          </a-select-option>
          <a-select-option key="标注员3">
            标注员3
          </a-select-option>&ndash;&gt;
        </a-select>-->

        <a-select v-model:value="form.excuteTeamId" placeholder="请选择标注团队" @change="teamChangeHandle"
                  @popupScroll="teamScrollHandle"
                  style="width: 150px">
          <a-select-option v-for="item in teamList" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-select v-model:value="form.excuteUserId" placeholder="请选择标注员" @popupScroll="memberScrollHandle" style="width: 150px">
          <a-select-option v-for="item in memberList" :key="item.userId">
            {{ getUserName(item.userId) }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
// import { getUserByPage } from '@/api/user'
import { getCompanyMember } from '@/api/company'
import { getTeamMember, getTeamByPage } from '@/api/team'
import { updateTask, getResetTask } from '@/api/task'
import { getUserName } from '@/filters'
import store from '@/store'
import { getDatasetItem } from '@/api/dataSet'
import { ref } from 'vue'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      visible: false,
      form: {
        name: '--',
        excuteUserId: ref(),
        excuteTeamId: ref()
      },
      page: {
        pageNum: 1,
        pageSize: 10
      },
      teamPage: {
        pageNum: 1,
        pageSize: 10
      },
      memberPage: {
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      roleId: store.state.currentRole.roleId,
      taskNum: '--',
      teamList: [],
      memberList: [],
      currentTeamId: '',
      teamMore: false,
      memberMore: false,
      isFirst: false
    }
  },
  methods: {
    getUserName,
    open () {
      this.visible = true
      this.form.excuteUserId = ref()
      this.form.excuteTeamId = ref()
      this.teamList = []
      this.memberList = []
      this.teamPage.pageNum = 1
      this.memberPage.pageNum = 1
      this.$nextTick(() => {
        this.form.name = this.currentItem.name
        // this.getData(1)
        this.getDataItems(1)
        this.getTeamList(1)
      })
    },
    teamScrollHandle (e) {
      if (e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 10 && this.teamMore) {
        const num = this.teamPage.pageNum
        this.teamPage.pageNum = num + 1
        this.getTeamList()
      }
    },
    getTeamList (pageNum) {
      if (pageNum) this.teamPage.pageNum = pageNum
      getTeamByPage({ ...this.teamPage, companyId: store.state.currentRole.companyId }).then(res => {
        const data = res.data.map.data
        const arr = this.teamList
        this.teamList = arr.concat(data.rows)
        if (this.teamList.length < data.total) {
          this.teamMore = true
        } else {
          this.teamMore = false
        }
      })
    },
    memberScrollHandle (e) {
      if (e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 10 && this.memberMore) {
        const num = this.memberPage.pageNum
        this.memberPage.pageNum = num + 1
        this.getMemberList()
      }
    },
    teamChangeHandle (value) {
      this.memberList = []
      this.currentTeamId = value
      this.isFirst = true
      this.getMemberList()
    },
    getMemberList () {
      getTeamMember({ ...this.memberPage, teamId: this.currentTeamId }).then(res => {
        const data = res.data.map.data
        const arr = this.memberList
        this.memberList = arr.concat(data.rows)
        if (this.memberList.length > 0) {
          if (this.memberList.length < data.total) {
            this.memberMore = true
          } else {
            this.memberMore = false
          }
          if (this.isFirst) {
            this.form.excuteUserId = data.rows[0].userId
            this.isFirst = false
          }
        } else {
          this.form.excuteUserId = ref()
        }
      })
    },
    changeHandle (value) {
      getTeamMember({ userId: value }).then(res => {
        if (res.data.map.data.rows) {

        }
      })
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      // console.log('999com=', store.state.currentRole)
      getCompanyMember({ ...this.page, companyId: store.state.currentRole.companyId }).then(async res => {
        const resData = res.data.map.data
        this.tableData = resData.rows
      })
      // 13 标注公司管理员   14 标注公司团队管理员
      /* if (this.roleId === 13) {
      } else if (this.roleId === 14) {
        getTeamMember({ ...this.page, teamId: store.state.currentRole.teamId, roleId: this.roleId }).then(async res => {
          const resData = res.data.map.data
          this.tableData = resData.rows
        })
      } */
      /* getUserByPage({ ...this.page }).then(async res => {
        const resData = res.data.data
        this.tableData = resData.rows
      }) */
    },
    getDataItems (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      getDatasetItem({
        datasetId: this.currentItem.datasetId,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }).then(res => {
        this.taskNum = res.total
      })
    },
    handleSubmit () {
      const self = this
      if (!self.form.excuteUserId) {
        self.$message.error('请选择标注员')
      } else {
        if (self.currentTeamId.reset) {
          getResetTask({ id: self.currentTeamId.id }).then(res => {
            // this.getDataItems(item, index)
            if (res.data.state === 'success') {
              setTimeout(function () {
                updateTask({
                  excuteUserId: self.form.excuteUserId, excuteTeamId: self.form.excuteTeamId, state: 'waiting_annotate', id: self.currentItem.id
                }).then(res => {
                  this.$message.success('任务已分配')
                  this.visible = false
                  this.$emit('refresh-data', this.currentItem.parentId)
                })
              }, 2000)
            }
          })
        } else {
          updateTask({
            excuteUserId: self.form.excuteUserId, excuteTeamId: self.form.excuteTeamId, state: 'waiting_annotate', id: self.currentItem.id
          }).then(res => {
            self.$message.success('任务已分配')
            self.visible = false
            self.$emit('refresh-data', self.currentItem.parentId)
          })
        }
      }
    },
    handleCancel () {
      this.visible = false
      // this.$emit('refresh-data', this.currentItem.parentId)
    }
  }
}
</script>
<style lang="less">

</style>
